import { buildApiUrl, API_ENDPOINTS, apiRequest } from '../config/api.js'

export const leaveRequestsApi = {
  // Get all leave requests visible to the current user
  // Employee: only their own, Manager: team members, Admin: all
  async getLeaveRequests(status = null) {
    let url = buildApiUrl(API_ENDPOINTS.LEAVES.ALL)
    if (status) {
      url += `?status=${status}`
    }
    return apiRequest(url)
  },

  // Get a specific leave request by ID
  async getLeaveRequest(id) {
    const url = buildApiUrl(API_ENDPOINTS.LEAVES.BY_ID(id))
    return apiRequest(url)
  },

  // Create a new leave request for the current user
  async createLeaveRequest(leaveData) {
    const url = buildApiUrl(API_ENDPOINTS.LEAVES.ALL)
    return apiRequest(url, {
      method: 'POST',
      body: JSON.stringify({ leave_request: leaveData }),
    })
  },

  // Approve a leave request (Manager/Admin only)
  async approveLeaveRequest(id) {
    const url = buildApiUrl(API_ENDPOINTS.LEAVES.APPROVE(id))
    return apiRequest(url, {
      method: 'PUT',
    })
  },

  // Reject a leave request (Manager/Admin only)
  async rejectLeaveRequest(id) {
    const url = buildApiUrl(API_ENDPOINTS.LEAVES.REJECT(id))
    return apiRequest(url, {
      method: 'PUT',
    })
  },

  // Cancel a leave request (if supported by backend)
  async cancelLeaveRequest(id) {
    const url = buildApiUrl(API_ENDPOINTS.LEAVES.CANCEL(id))
    return apiRequest(url, {
      method: 'PUT',
    })
  }
}
